<template>
  <div class="p-6 bg-white rounded-lg">
    <div class="flex items-center mb-4 pb-4 border-b">
      <div class="w-12 h-12 rounded-lg text-white p-1 bg-tertiary">
        <icon name="market_reports" />
      </div>
      <h3 class="text-2xl font-medium ml-4">
        LeadPro Status
      </h3>
    </div>
       <div class="lps-content">
      <div v-if="! isResolving">
        <div v-if="! hasErrored">
          <div v-if="this.leadProData.hasOwnProperty('account_name')">
            <div v-if="! this.leadProData.active">
              <div class="lps-active-warning">
                <div class="lps-active-warning-status">
                  <p>LeadPro Status: <strong>Inactive</strong></p>
                  <div class="tag-bubble-inline alert-tag">
                    <i class="fas fa-exclamation" />
                  </div>
                </div>
                <div class="bg-yellow-dark lps-active-warning-message">
                  <p v-if="this.system.networks[0].id === GUILD_NETWORK_ID" class="">Your office is registered with Guild LeadPro, however your portal enquiry feeds are not working.</p>
                  <p v-else-if="this.fc_network_array.indexOf(this.system.networks[0].id) !== -1" class="">Your office is registered with F&C LeadPro, however your portal enquiry feeds are not working.</p>
                  <p v-else>Your office is registered with LeadPro, however your portal enquiry feeds are not working.</p>
                </div>
                <p>Target Email Address: <a class="lps-active-warning-email-target" :herf="'mailto:' + this.leadProData.target_email">{{ this.leadProData.target_email ? this.leadProData.target_email : 'Unknown' }}</a></p>
                <strong class="lps-activity-title">Activity History</strong>
                <table class="lps-active-warning-table">
                  <thead>
                    <th>Source</th>
                    <th>Type</th>
                    <th>Last Received</th>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in this.leadProData.activity" :key="index">
                      <td class="capitalize">{{ row.source }}</td>
                      <td>{{ row.lead_type }}</td>
                      <td :class="healthyDate(row.last_received)">{{ row.last_received | datetime }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-else>
              <div class="lps-active">
                <div class="lps-active-status">
                  <p>LeadPro Status: <strong>Active</strong></p>
                  <div class="tag-bubble-inline success-tag">
                    <i class="fas fa-check" />
                  </div>
                </div>
                <p v-if="selectedOffice && selectedOffice.associate" class="lps-active-email">
                  Target Email Address: Set
                </p>
                <p v-else class="lps-active-email">Target Email Address: <a class="lps-active-email-target" :herf="'mailto:' + this.leadProData.target_email">{{ this.leadProData.target_email ? this.leadProData.target_email : 'Unknown' }}</a></p>
                <strong class="lps-activity-title">Activity History</strong>
                <table class="lps-active-table">
                  <thead>
                    <th>Source</th>
                    <th>Type</th>
                    <th>Last Received</th>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in this.leadProData.activity" :key="index">
                      <td class="capitalize">{{ row.source }}</td>
                      <td>{{ row.lead_type }}</td>
                      <td v-if="selectedOffice &&  selectedOffice.associate" >Received</td>
                      <td v-else :class="healthyDate(row.last_received)">{{ row.last_received | datetime }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div v-else>
            <div v-if="isSignUpResolving">
              <loader />
            </div>
            <div v-else>
              <p v-if="this.system.networks[0].id === GUILD_NETWORK_ID" class="mb-3">You are not currently signed up for the Guild LeadPro service. Please use the button below to sign up for the service.</p>
              <p v-else-if="this.fc_network_array.indexOf(this.system.networks[0].id) !== -1" class="mb-3">You are not currently signed up for the Fine and Country LeadPro service. Please use the button below to sign up for the service.</p>
              <p v-else class="mb-3">You are not currently signed up for the LeadPro service. Please use the button below to sign up for the service.</p>
              <div v-if="! hasSignUpErrored">
                <a v-if="this.system.networks[0].id === GUILD_NETWORK_ID" :href="this.signUpUrl" target="_blank" rel="noopener noreferrer" class="mb-2 p-3 inline-block no-underline bg-secondary button-text-color text-center text-sm w-full rounded uppercase">
                  SIGN UP
                </a>
                <a v-else-if="this.fc_network_array.indexOf(this.system.networks[0].id) !== -1" :href="this.signUpUrl" target="_blank" rel="noopener noreferrer" class="mb-2 p-3 inline-block no-underline bg-secondary button-text-color text-center text-sm w-full rounded uppercase">
                  SIGN UP
                </a>
                <a v-else :href="this.signUpUrl" target="_blank" rel="noopener noreferrer" class="mb-2 p-3 inline-block no-underline bg-secondary button-text-color text-center text-sm w-full rounded uppercase">
                  SIGN UP
                </a>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="lps-error">
            <div class="tag-bubble-inline alert-tag">
              <i class="fas fa-exclamation" />
            </div>
            <p>
              <strong>Whoops! Looks like something went wrong.</strong>
            </p>
          </div>
        </div>
      </div>
      <loader v-else></loader>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import api from '@/http'
import moment from 'moment'
import {
  GUILD_NETWORK_ID,
  FC_NETWORK_ID,
  FC_INTL_NETWORK_ID,
  LEADPRO_ASSOCIATE_ID
} from '@/consts'

export default {
  data () {
    return {
      isResolving: true,
      isSignUpResolving: true,
      hasErrored: false,
      hasSignUpErrored: false,
      leadProData: {},
      signUpUrl: '',
      GUILD_NETWORK_ID,
      FC_NETWORK_ID,
      FC_INTL_NETWORK_ID,
      LEADPRO_ASSOCIATE_ID,
      fc_network_array: [
        FC_NETWORK_ID,
        FC_INTL_NETWORK_ID
      ]
    }
  },
  created () {
    this.fetchLeadProStatus()
    this.fetchLeadProSignUp()
  },
  computed: {
    ...mapState([
      'selectedOffice', 'profile', 'system'
    ])
  },
  methods: {
    fetchLeadProStatus () {
      this.isResolving = true
      var officeId = this.selectedOffice.id
      api.get(`/leadpro/office/${officeId}/activity`)
        .then(response => {
          this.leadProData = response.data
          this.isResolving = false
        })
        .catch(() => {
          this.hasErrored = true
          this.isResolving = false
        })
    },
    fetchLeadProSignUp () {
      var officeId = this.selectedOffice.id
      api.get(`/leadpro/office/${officeId}/signup`)
        .then(response => {
          this.signUpUrl = 'https://dashboard.lead.pro/signup?' + response.data.url
          this.isSignUpResolving = false
          this.hasSignUpErrored = false
        })
        .catch(() => {
          this.hasSignUpErrored = true
          this.isSignUpResolving = false
        })
    },
    healthyDate (date) {
      if ((moment().diff(date, 'days') <= 2)) {
        return 'text-green'
      }
      if ((moment().diff(date, 'days') < 7)) {
        return 'text-orange-dark'
      }
      return 'text-red'
    }
  },
  watch: {
    selectedOffice () {
      this.fetchLeadProStatus()
      this.fetchLeadProSignUp()
    }
  }
}
</script>
<style lang="scss" scoped>
.lps-active-warning-status {
  display: flex;
  .tag-bubble-inline {
    margin: -5px 0 0 5px;
  }
}
.lps-active-status {
  display: flex;
  .tag-bubble-inline {
    margin: -5px 0 0 5px;
  }
}
.lps-active-email {
  margin: .25rem 0;
}
.lps-active-email-target {
  word-break: break-all;
}
.lps-active-warning-email-target {
  word-break: break-all;
}
.lps-active-warning-message {
  padding: .35rem;
  margin: .5rem 0;
  border-radius: 3px;
}
.lps-active-warning-table, .lps-active-table {
  border: 1px solid black;
  margin: .5rem 0;
  th, td {
    width: calc(100% / 3);
    text-align: center;
    border: 1px solid black;
  }
}
.lps-activity-title {
  margin: .5rem 0 0 0;
  display: block;
}
.lps-error {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .tag-bubble-inline {
    margin: .5rem 0;
  }
}
</style>
